<template>
  <div class="main">
    <van-nav-bar title="投票详情" left-arrow @click-left="onClickLeft" />

    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <div class="container" v-if="!pdfView">
        <div class="top">
          <p class="title">{{ currentData.gsmc }}</p>
          <div class="btn">
            <div class="voteBottom">
              <div class="VoteType">使用公示</div>
            </div>
          </div>
        </div>
        <div class="content">
          <img
            class="images"
            width="77px"
            height="88px"
            src="../../assets/img/img_gongshi.png"
          />
          <div>公示描述:</div>

          <p class="content-title">
            {{ currentData.gsms }}
          </p>

          <p class="vote-time" style="margin-bottom: 5px">设备设施类型：</p>
          <p class="title-info">{{ currentData.sssblx }}</p>
          <!-- <p style="font-size: 14px"></p> -->

          <p class="vote-time">公示时间：</p>
          <div class="voteName">
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_begin.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.gsfqsj }}
            </div>
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_over.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.gsjssj }}
            </div>
          </div>

          <p class="vote-time" v-if="currentData.gslx == 0">验收时间：</p>
          <p class="title-info" v-if="currentData.gslx == 0">
            {{ currentData.yjsgyssj }}
          </p>
          <p class="vote-time">附件：</p>
          <div v-if="currentData.fjurlList.length > 0">
            <div v-if="currentData.gslx != 0">
              <div class="example">
                <img
                  v-for="(item, index) in oneList"
                  :key="index"
                  class="one"
                  :src="item.url"
                  alt=""
                />
                <!-- @click="viewImg(item.url)"  -->
              </div>
              <div class="example">
                <img
                  v-for="(item, index) in twoList"
                  :key="index"
                  class="one"
                  :src="item.url"
                  alt=""
                />
                <!-- @click="viewImg(item.url)" -->
              </div>
            </div>
            <div v-else>
              <div
                class="upload"
                v-for="(item, index) in currentData.fjurlList"
                :key="index"
              >
                <div class="upload-item" @click="download(item)">
                  <img
                    class="item-left"
                    src="../../assets/img/ico_file.png"
                    alt=""
                  />
                  <div class="item-middle">
                    <p class="upload-text">{{ item.name }}</p>
                    <span class="upload-file">{{ item.size }}</span>
                  </div>
                  <img
                    class="item-right"
                    src="../../assets//img//ico_download_big.png"
                    alt=""
                    @click="download(item)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-else class="title-info">暂无</div>

          <p class="vote-time">涉及房屋列表：</p>
          <table
            style="width: 100%; border-collapse: collapse"
            border-collapse="collapse"
          >
            <tr>
              <th>楼幢单元室号</th>
              <th>房屋面积</th>
              <th>分摊金额</th>
            </tr>
            <tr v-for="(item, index) in currentData.fwlb" :key="index">
              <td>{{ item.fwmc }}</td>
              <td>{{ item.fwmj }}<span style="font-size: 10px">m²</span></td>
              <td>{{ item.ftje }}<span style="font-size: 10px">元</span></td>
            </tr>
          </table>
        </div>
      </div>
    </van-pull-refresh>
    <!-- 预览pdf -->
    <div v-if="pdfView" style="height: calc(100% - 46px)">
      <pdfPage :pdfSrc="pdfUrl"></pdfPage>
    </div>

    <van-dialog
      v-model="signShow"
      title="附件预览"
      width="300px"
      height="200px"
      :show-confirm-button="false"
      show-cancel-button
    >
      <div style="width: 100%; height: 100%">
        <img
          :src="currentUrl"
          style="width: 100%; height: 160px; margin: 10px auto"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/api/public.js";
import pdfPage from "./pdfNoPage.vue";
export default {
  name: "",
  components: {
    pdfPage,
  },
  data() {
    return {
      loading: false,
      show: true,
      pdfUrl: "",
      pdfView: false,
      currentData: {
        fjurlList: [],
      },
      currentUrl: "",
      signShow: false,
      oneList: [],
      twoList: [],
      status: "1", // 1已投票  0 未投票
    };
  },

  created() {},
  mounted() {
    this.init();
  },
  methods: {
    onClickLeft() {
      window.history.go(-1);
    },
    init() {
      this.loading = true;
      api
        .getDetail(this.$route.query.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.currentData = res.data.data;

            // 文件替换为外网ip
            if (res.data.data.fileDto.length > 0) {
              res.data.data.fileDto.forEach((item) => {
                item.url = item.url.replace(
                  "http://172.17.20.11:9000",
                  "http://222.214.193.17:9000"
                );
              });
            }

            if (this.currentData.gslx != 0) {
              if (
                res.data.data.fjurlList &&
                res.data.data.fjurlList.length > 3
              ) {
                this.oneList = res.data.data.fjurlList.slice(0, 3);
                this.twoList = res.data.data.fjurlList.slice(
                  3,
                  res.data.data.fjurlList.length
                );
              } else {
                this.oneList = res.data.data.fjurlList;
              }
            }

            this.currentData.fwlb = res.data.data.fwlb || [];
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onRefresh() {
      this.init();
    },
    yulan(item) {
      this.pdfUrl = item.url;
      this.pdfView = true;
      // this.$router.push({
      //     path: "/preview",
      //     query: { pdfUrl: item.url},
      //   });
    },
    download(file) {
      api
        .minioDownload({ url: file.url })
        .then((res) => {
          // var fileName = res.headers("Content-Disposition").split(";")[1].split("filename=")[1];
          // var fileNameUnicode = res.headers("Content-Disposition").split("filename*=")[1];
          // if (fileNameUnicode) {// filename* 时，取filename* 并进行解码
          //     fileName = decodeURIComponent(fileNameUnicode.split("''")[1]);
          // }
          let blob = new Blob([res.data], {
            type: "application/octet-stream",
          });
          if ("msSaveOrOpenBlob" in navigator) {
            // IE导出
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          }
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = file.name; //下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$toast("下载失败，请稍后重试！");
        });
    },
    viewImg(url) {
      this.currentUrl = url;
      this.signShow = true;
      console.log("123", this.signShow);
    },
  },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  position: sticky;
  z-index: 999;
  top: 0;
}

.main {
  height: 100%;
  background-color: #f4f7f9;
  background: linear-gradient(
    180deg,
    rgba(255, 216, 193, 0.42) 0%,
    rgba(255, 216, 193, 0) 100%
  );

  .container {
    width: 100%;
    padding: 20px;

    // padding-bottom: 20px;
    .top {
      width: 100%;
      min-height: 140px;
      overflow: hidden;
      position: relative;

      .title {
        position: relative;
        z-index: 9;
        width: 100%;
        min-height: 30px;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222120;
        line-height: 30px;
        margin: 0;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }

      .btn {
        margin-top: 10px;

        .join {
          width: 120px;
          height: 30px;
          background: #f7f7f7;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #e9e9e9;
          font-size: 13px;
        }

        .vote {
          width: 80px;
          height: 30px;
          font-size: 13px;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #00c797;
        }
      }

      .images {
        position: absolute;
        z-index: 1;
        top: 45px;
        right: 0px;
        width: 120px;
        height: 110px;
        // background: #f4f7f9;
        // box-shadow: inset 2px 2px 6px 0px rgba(255, 255, 255, 0.6);
        opacity: 1;
      }
    }

    .content {
      position: relative;
      width: 100%;
      height: 100%;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      padding: 16px;

      .images {
        position: absolute;
        top: -94px;
        right: 0px;
        width: 120px;
        height: 110px;
        // background: #f4f7f9;
        // box-shadow: inset 2px 2px 6px 0px rgba(255, 255, 255, 0.6);
        opacity: 1;
      }

      .title-info {
        font-size: 14px;
        color: #4e4d4d;
        font-weight: 500;
        min-height: 30px;
        line-height: 30px;
        margin: 0;
      }
    }
  }
}

.voteBottom {
  //   padding: 0 16px;
  margin: 15px 0;

  button {
    padding: 0 17px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ff6c1a;
    color: #fff;
    border-radius: 30px;
    float: right;
    border: none;
    font-size: 13px;
  }

  .voteIn,
  .VoteType {
    display: inline-block;
    font-size: 13px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 3px;
  }

  .voteIn {
    background: #f7f7f7;
    color: #6b6a6a;
    border: 1px solid #e9e9e9;
    letter-spacing: 1px;

    img {
      // margin-top: 5px;
      margin-top: 6px;
      margin-right: 5px;
      float: left;
      width: 16px;
      height: 16px;
    }
  }

  .VoteType {
    color: #00c797;
    background: rgba(0, 199, 151, 0.05);
    border: 1px solid #00c797;
    margin-left: 5px;
  }
}

.voteName {
  margin-top: 16px;
  padding: 0 16px;
  display: flex;

  img {
    display: block;
    width: 22px;
    height: 22px;
  }

  .name {
    // flex: 1;
    width: 85px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: 5px;
    color: #4e4d4d;
    line-height: 16px;
    overflow: hidden;
    margin-right: 10px;
  }
}

.content-title {
  width: 100%;
  min-height: 30px;
  word-break: break-all;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #4e4d4d;
  line-height: 30px;
}

.example {
  display: flex;

  .one {
    width: 31.5%;
    height: 96px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-right: 10px;
  }
}

.vote-time {
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #4e4d4d;
  line-height: 19px;
}

.upload {
  min-height: 62px;

  .upload-item {
    display: flex;
    width: 100%;
    height: 52px;
    // justify-content: center;
    border: 1px solid #eee;
    padding: 0 18px;
    margin-bottom: 10px;

    .item-left {
      width: 24px;
      height: 29px;
      margin-top: 12px;
    }

    .item-middle {
      flex: 1;
      width: 80%;
      height: 30px;
      margin-top: 8px;
      margin-left: 10px;

      .upload-text {
        font-size: 14px;
        margin: 0;
        font-weight: 500;
        color: #4e4d4d;
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .upload-file {
        font-size: 12px;
        font-weight: 500;
      }
    }

    .item-right {
      margin-top: 12px;
      width: 20px;
      height: 20px;
    }
  }
}

table {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}

table th {
  height: 30px;
  background-color: #f4f4f5;
  color: #999998;
  font-weight: 500;
}

table thead th {
  background-color: #cce8eb;
  width: 100px;
  border-bottom: 1px solid #eee;
}

table tr {
  height: 50px;
  color: #4e4d4d;
  border-bottom: 1px solid #eee;
}

table tr:nth-child(odd) {
  background: #fff;
}

table tr:nth-child(even) {
  background: #fff;
}
</style>
